import type { VFC } from 'react';
import { AuthenticatedApp } from 'containers/auth';
import { useRecoilValue } from 'recoil';
import { sessionState } from 'store';
import { PublicRouter } from './Router';

export const PublicApp: VFC = () => {
  const { isAuthenticated } = useRecoilValue(sessionState);
  return isAuthenticated ? <AuthenticatedApp /> : <PublicRouter />;
};
